export const RERUN_MESSAGE_SOURCE = {
  REPORT: 'report',
  PLAN: 'plan',
};
